import React, { createContext, ReactNode, useContext, useState } from 'react';

interface IQueryParams {
  query?: string;
  sort?: string | string[];
}

const INITIAL_PARAMS = {
  query: '',
  sort: '',
};

interface IContext {
  queryParams: IQueryParams;
  setQueryParams: (data: IQueryParams) => void;
  resetQueryParams: () => void;
}

const ProjectDataContext = createContext<IContext>(null!);

function ProjectDataProvider({ children }: { children: ReactNode }) {
  const [queryParams, setQueryParams] = useState<IQueryParams>(INITIAL_PARAMS);

  const resetQueryParams = () => setQueryParams(INITIAL_PARAMS);

  const value = {
    queryParams,
    setQueryParams,
    resetQueryParams,
  };

  return <ProjectDataContext.Provider value={value}>{children}</ProjectDataContext.Provider>;
}

const useProjectDataParams = () => {
  const context = useContext(ProjectDataContext);

  if (context === undefined) {
    throw new Error('useRecipientContacts must be used within a RecipientContactsProvider');
  }

  return context;
};

export { ProjectDataContext, ProjectDataProvider, useProjectDataParams };
